import axios from 'axios';
import appPlugin from '@lib';
import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import locale from 'element-plus/lib/locale/lang/zh-cn';
import 'dayjs/locale/zh-cn';
import commonPlugin from '@common';
import compsPlugin from '@teacher-c';
import vue3videoPlay from 'vue3-video-play'; // 引入组件
import App from './App.vue';
import router from './router';
import apiPlugin from './api/index';
import libPlugin from './common-lib';
import storePlugin from './store';
import popups from './popup/index';
import queryAllPlugin from './query-all';

import 'element-plus/dist/index.css';
import '@teacher/assets/scss/reset.css';
import '@teacher/assets/scss/bem.scss';
import 'vue3-video-play/dist/style.css';
// 引入css
const application = createApp(App);
application
  .use(ElementPlus, { locale, size: 'default' })
  .use(appPlugin)
  .use(router)
  .use(commonPlugin, popups)
  .use(apiPlugin)
  .use(libPlugin)
  .use(storePlugin)
  .use(queryAllPlugin)
  .use(compsPlugin)
  .use(vue3videoPlay);

// 设置OSS上传前需要获取token的api
const {
  api,
  app: { tool, http },
} = application.config.globalProperties;

// OSS上传相关配置
window.xgjzt.oss.setConfig({
  axios,
  max: 2,
  env: process.env.VUE_APP_x3_env,
  getStsParams: api.getOssRequest,
  isEncrypt:true,
  fileNameType:2, // 1原文件名，2随机文件名
});

// 为了与后端调试方便
const { name } = tool.parseQuery();
if (name) {
  http.setHeader('x3-version', name);
}

application.provide('global', application.config.globalProperties);
application.provide('x3-ga4-analytics', { x3SendGtag: (navMenu, buttonName, config = {}) => {
  setTimeout(() => {
    // eslint-disable-next-line no-undef
    gtag('event', 'x3-pc-event-menu', { x3_web_env: process.env.VUE_APP_x3_env,
      x3_pc_bunisess_type: 'x3-PC-老师端',
      x3_client_type: tool.getBrowserType(),
      x3_company_name: application.config.globalProperties.store.user.value.companyInfoVo.companyName,
      x3_page_menu_button: `【${navMenu}-${buttonName}】`,
      x3_nav_menu_name: navMenu,
      x3_page_alias: `${document.title}-${navMenu}`,
      ...config });
  }, 301);
} });
/* 错误日志收集，相关配置 */
function sentryConfig(data) {
  if (window.Sentry) {
    const user = data.userInfo;
    const cname = user.companyInfoVo && user.companyInfoVo.companyName;
    const uname = user && user.name;
    window.Sentry.configureScope((scope) => {
      /** 以公司名称作为用户信息 */
      scope.setUser({
        _x3_机构名: cname,
        _x3_操作人: uname,
      });
      // 添加自定义标签
      scope.setTag('_x3_operatorType_', 'teacher');
      scope.setTag('_x3_env_', process.env.VUE_APP_x3_env);
      scope.setTag('_x3_company_', cname);
    });

    application.config.errorHandler = (err) => {
      console.error(err);
      window.Sentry.captureMessage(err);
    };
  }
}

api.businessLogin().then((res) => {
  application.provide('businessLoginData', res.data);
  application.mount('#app');
  application.config.globalProperties.priceUnit = res.data.businessInfo?.lessonUnit;
  application.provide('priceUnit', res.data.businessInfo?.lessonUnit);
  application.config.globalProperties.dayUnit = '天';
  application.provide('dayUnit', '天');
  // 设置浏览器标题
  window.document.title = res?.data?.userInfo?.companyInfoVo?.companyName || '云校';
  sentryConfig(res.data);
});
